import React from "react";
import { ArrowUpRight } from "lucide-react";
import { IMG } from "@/lib/site";

export default function BrandConnection() {
  return (
    <section
      id="brand"
      data-testid="section-brand"
      className="bg-ice-light py-20 lg:py-28"
    >
      <div className="container-pc">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center max-w-5xl mx-auto">
          <figure className="rounded-2xl bg-white border border-silver/40 overflow-hidden shadow-card order-1 lg:order-1">
            <img
              src={IMG.hero}
              alt="PeptiChill cooler with the Peptigen Labs logo visible on the front face of the unit"
              className="block w-full max-w-full h-full object-cover blend-product"
              loading="lazy"
              width="700"
              height="700"
            />
          </figure>

          <div className="order-2 lg:order-2">
            <p className="eyebrow">Peptigen Labs Sister Brand</p>
            <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold text-navy tracking-tighter">
              From the team behind Peptigen Labs.
            </h2>
            <p className="mt-6 text-base lg:text-[17px] text-muted leading-[1.8]">
              PeptiChill was created to provide a clean, professional storage solution for
              research-use peptides and temperature-sensitive laboratory materials — built
              with the same UK-based engineering standards behind Peptigen Labs.
            </p>
            <p className="mt-4 text-base lg:text-[17px] text-muted leading-[1.8]">
              Every PeptiChill unit ships with the Peptigen Labs identity printed on the
              front panel — a visible mark of the engineering standards behind it.
            </p>
            <a
              href="https://peptigenlabs.co.uk"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="brand-peptigen-link"
              className="mt-7 inline-flex items-center gap-1.5 text-navy font-semibold text-sm hover:text-cyan transition-colors"
            >
              Visit Peptigen Labs
              <ArrowUpRight size={16} strokeWidth={2.2} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
